import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated$.pipe(
    take(1),
    map((isAuthenticated) => {
      if (isAuthenticated) {
        return true;
      }

      // A 404 is no destination worth returning to after sign-in.
      if (state.url === '/not-found') router.navigate(['/login']);
      else router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }),
  );
};
